import { getMonthName } from "../../utils/dateUtils";
import { LINE_ENUM } from "../../constants/enums.js";
import { triggerDownload } from "../../utils/downloadUtils.js";

export const getLineLabelById = (id) =>
  Object.values(LINE_ENUM).find((l) => l.id === Number(id))?.label || "";

export const walletColumns = [
  {
    field: "month",
    header: "Mes",
    columnType: "custom",
    render: (row) => (
      <div className="wallet-file-chips">{getMonthName(row.month)}</div>
    )
  },
  { field: "year", header: "Año", align: "center" },

  {
    field: "line",
    header: "Línea de Negocio",
    columnType: "custom",
    render: (row) => <span>{getLineLabelById(row.lineId)}</span>
  },

  {
    field: "files",
    header: "Archivos",
    columnType: "custom",
    render: (row) => (
      <div className="wallet-file-chips">
        {(row.files || []).map((file, idx) => (
          <span
            key={idx}
            className="wallet-file-chip"
            title={file.name}
            onClick={() => triggerDownload(file.path || file.url, file.name)}
          >
            {file.shortLabel}
          </span>
        ))}
      </div>
    )
  },
  {
    field: "actionButtons",
    header: "",
    columnType: "actionButtons"
  }
];


export const walletCollectionColumns = [
  {
    field: "month",
    header: "Mes",
    columnType: "custom",
    render: (row) => (
      <div className="wallet-file-chips">{getMonthName(row.month)}</div>
    )
  },
  { field: "year", header: "Año", align: "center" },
];